import React, { useMemo } from "react";
import { useLocation } from "react-router-dom";
import Seo from "./Seo";
import { getFxSolutionBySlug, getServiceBySlug } from "../lib/constants";
import { canonicalUrl, getSeoForPath, serviceJsonLd } from "../lib/seo";

/** Applies route-aware SEO on every navigation. */
export default function RouteSeo() {
  const { pathname } = useLocation();
  const seo = getSeoForPath(pathname);

  const extraJsonLd = useMemo(() => {
    const solutionMatch = pathname.match(/^\/solutions\/([^/]+)$/);
    if (solutionMatch) {
      const solution = getFxSolutionBySlug(solutionMatch[1]);
      if (solution) {
        return serviceJsonLd({
          name: solution.title,
          description: solution.intro,
          url: canonicalUrl(pathname),
        });
      }
    }
    const serviceMatch = pathname.match(/^\/services\/([^/]+)$/);
    if (serviceMatch) {
      const service = getServiceBySlug(serviceMatch[1]);
      if (service) {
        return serviceJsonLd({
          name: service.title,
          description: service.intro,
          url: canonicalUrl(pathname),
        });
      }
    }
    return null;
  }, [pathname]);

  return (
    <Seo
      title={seo.title}
      description={seo.description}
      keywords={seo.keywords}
      path={pathname}
      image={seo.image}
      type={seo.type}
      jsonLd={extraJsonLd}
    />
  );
}
